import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveBeneficiariesStepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveBeneficiariesStep = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveBeneficiariesStepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveBeneficiariesStep
      ? parseLegalClient(data.legalClientSaveBeneficiariesStep)
      : undefined,
    loading,
    error,
    saveBeneficiariesStep: useCallback(
      async (id: string) => {
        const res = await handle({
          variables: {
            id,
          },
        });
        return res.data?.legalClientSaveBeneficiariesStep
          ? parseLegalClient(res.data.legalClientSaveBeneficiariesStep)
          : undefined;
      },
      [handle]
    ),
  };
};
